// extracted by mini-css-extract-plugin
export var logo = "_kg-2";
export var logoWrapper = "_kg-1";
export var strip = "_kg-0";